import React from 'react';
import { motion } from 'framer-motion';
import { painPoints } from '../data/painPoints';
export function PainPoints() {
  return <section className="py-24 px-4 bg-cream" data-id="element-118" data-mp="2lmspylv9v6kb">
      <div className="max-w-4xl mx-auto" data-id="element-119" data-mp="26yfudq03jpqc">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-center mb-12" data-id="element-120" data-mp="26xmsb2c31oej">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-navy" data-id="element-121" data-mp="21z37545bcgn8">
            Does this sound familiar?
          </h2>
          <p className="text-lg text-ink leading-relaxed bg-cream-card p-6 rounded-2xl border border-gold-light shadow-sm text-left" data-id="element-122" data-mp="1o0vcx3znvtfr">
            Sunday evening. You have another Taekwondo class tomorrow. And instead of resting, you
            are still searching for drills, deciding which techniques to teach, trying to create a
            progression that makes sense, and wondering whether the session will actually work for
            the students who walk through the door.
            <br data-id="element-123" data-mp="1u2dh8c45javy" />
            <br data-id="element-124" data-mp="1u0so8qxhk007" />
            <span className="text-navy font-semibold" data-id="element-125" data-mp="1u1bv9clll3zg">
              Not because you don&apos;t know Taekwondo.
            </span>{' '}
            Because nobody gave you a complete, structured teaching system that tells you what to
            teach, how to progress it and how to turn it into a professional class. So every week,
            you start again.
            <br data-id="element-126" data-mp="1b3hluxgk4qgj" />
            <br data-id="element-127" data-mp="1b415ciluvmwo" />
            The time you should be resting becomes planning time. And the hardest part is not even
            the time. It is walking into class knowing you could have been more prepared.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-128" data-mp="1k5qv7k03adsc">
          <h3 className="text-xl font-bold text-navy mb-8 text-center" data-id="element-129" data-mp="1t5oi4vgv83w9">
            The real cost of planning everything from scratch:
          </h3>
          <div className="overflow-hidden rounded-xl border border-gold-light bg-cream-card shadow-sm" data-id="element-130" data-mp="1y2exfgkuivgm">
            {painPoints.map((point, index) => <motion.p key={point} initial={{
            opacity: 0,
            x: -12
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.25,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="px-5 py-4 text-ink text-sm leading-relaxed border-t first:border-t-0 border-gold-light" data-id="element-131" data-mp="275g017ai64fj" data-mpi={index}>
                <span className="mr-2 text-gold" data-id="element-132" data-mp="1o6u19z2gkpes">●</span>
                {point}
              </motion.p>)}
          </div>

          <div className="text-center mt-12 pt-8 border-t border-gold-light" data-id="element-133" data-mp="qolkqj7i3k5q">
            <p className="text-2xl font-serif font-bold text-navy" data-id="element-134" data-mp="vo6lmz68e2l3">
              Your knowledge is already there. What you need is a{' '}
              <span className="text-gold" data-id="element-135" data-mp="j75ie6dis7p7">system</span> that helps you use it faster and more
              consistently.
            </p>
            <p className="text-xl mt-4 text-navy-medium" data-id="element-136" data-mp="e713gks9fl13">
              Solve an entire year of Taekwondo classes in just 5 minutes.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}